<template>
  <div class="progress" :class="wrapperClasses">
    <div
      class="progress-bar"
      role="progressbar"
      :class="innerClasses"
      :style="{ width: percent + '%' }"
      :aria-valuenow="current"
      :aria-valuemin="min"
      :aria-valuemax="max"
      aria-labelledby="progress-bar-label"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WCProgressBar',
  props: {
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 100,
    },
    current: {
      type: Number,
      required: true,
    },
    variant: {
      type: String,
      validator: value => ['primary', 'success', 'danger', 'warning', 'info'].includes(value),
      default: 'primary',
    },
    animated: {
      type: Boolean,
      default: false,
    },
    striped: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      validator: value => ['small', 'default', 'large', 'xl'].includes(value),
      default: 'default',
    },
  },
  computed: {
    percent() {
      return Math.min(this.current / (this.max + this.min), 1) * 100;
    },
    innerClasses() {
      const classes = [];
      classes.push(`bg-${this.variant}`);
      if (this.animated) {
        classes.push('progress-bar-animated');
      }
      if (this.striped) {
        classes.push('progress-bar-striped');
      }
      return classes;
    },
    wrapperClasses() {
      const classes = [];
      switch (this.size) {
        case 'small':
          classes.push(`progress-bar-sm`);
          break;
        case 'large':
          classes.push(`progress-bar-lg`);
          break;
        case 'xl':
          classes.push(`progress-bar-xl`);
          break;
        default:
          break;
      }
      return classes;
    },
  },
};
</script>

<style scoped>
.progress-bar-sm {
  height: 0.5rem;
}
.progress-bar-lg {
  height: 2rem;
}
.progress-bar-xl {
  height: 3rem;
}
</style>
